/* Даты — строками YYYY-MM-DD, без часовых поясов браузера */
export const RU = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const DOW = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
export const MON = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
export const MON_S = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
export const MONTHS_N = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

export const D = (s: string) => new Date(s + 'T00:00:00');
export const iso = (d: Date) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
export const addDays = (s: string, n: number) => {
  const d = D(s);
  d.setDate(d.getDate() + n);
  return iso(d);
};
export const dowMon = (s: string) => (D(s).getDay() + 6) % 7;
export const today = () => iso(new Date());
export const monthStart = (s: string) => s.slice(0, 7) + '-01';
export const monthEnd = (s: string) => {
  const [y, m] = s.split('-').map(Number);
  return iso(new Date(y, m, 0));
};
export const shiftMonth = (ym: string, n: number) => {
  const [y, m] = ym.split('-').map(Number);
  const d = new Date(y, m - 1 + n, 1);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
};
/** «Понедельник, 5 октября»; год — если не текущий */
export const longDate = (s: string) => {
  const d = D(s);
  return `${DOW[dowMon(s)]}, ${d.getDate()} ${MON[d.getMonth()]}${d.getFullYear() !== new Date().getFullYear() ? ' ' + d.getFullYear() : ''}`;
};
/** «Пн, 5 окт» */
export const shortDate = (s: string) => {
  const d = D(s);
  return `${RU[dowMon(s)]}, ${d.getDate()} ${MON_S[d.getMonth()]}`;
};
export const dm = (s: string) => s.slice(8, 10) + '.' + s.slice(5, 7);
